import {RootState} from "../store";

export const getAccount = (store: RootState) => store.auth.account;
